module.exports = __webpack_public_path__ + "24b23490023e318f9c08cf94253542a0.png";